import React from "react";
import Button from "components/Common/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { dismissWindowAlertAction } from "actions/windowAlert";
import "./style.scss";

class WindowAlert extends React.Component {
  renderImage() {
    const imageUrl = this.props.windowAlert.get("image");

    if (imageUrl) {
      return (
        <img className="WindowAlert__inner-container__image" src={imageUrl} alt="" />
      );
    }

    return null;
  }

  renderActions() {
    switch (this.props.windowAlert.get("type")) {
      case "reload":
        return (
          <div className="WindowAlert__inner-container__actions">
            <Button
              onClick={() => window.location.reload()}
              title="Update and reload your app"
              text="Update"
              icon="Sync"
              fillColor="white"
            />
          </div>
        );
      default:
        return undefined;
    }
  }

  render() {
    const { windowAlert } = this.props;

    return (
      <div
        className={`WindowAlert ${windowAlert.get("isVisible")
          ? "WindowAlert--active"
          : ""}`}
      >
        {/* No need for keyboard handler */}
        <div // eslint-disable-line jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus, max-len
          className="WindowAlert__mask"
          role="button"
          aria-label="Dismiss"
          onClick={
            !windowAlert.get("actionRequired") && this.props.dismissWindowAlert
          }
        />
        <div className="WindowAlert__container">
          <div className="WindowAlert__inner-container">
            <div className="WindowAlert__inner-container__title">
              {windowAlert.get("title")}
            </div>
            <div className="WindowAlert__inner-container__content">
              {this.renderImage()}
              {windowAlert.get("content")}
            </div>
            {this.renderActions()}
          </div>
        </div>
      </div>
    );
  }
}

function mapState(state) {
  const { windowAlert } = state;

  return { windowAlert };
}

function mapDispatch(dispatch) {
  return {
    dismissWindowAlert: bindActionCreators(dismissWindowAlertAction, dispatch)
  };
}

const Connector = connect(mapState, mapDispatch)(WindowAlert);

export default Connector;
